import { filter, map, race, take, tap, timer } from 'rxjs'

import { safeBase64Encode } from '../../utils/base64'
import { latestAuthState$ } from '../auth/state'

export const ketchScriptTag$ = race(
  // try to resolve authentication state before loading Ketch SDK so that identities are available
  latestAuthState$.pipe(
    filter(({ isLoading }) => !isLoading),
    take(1),
  ),
  // wait up to two seconds for authentication state to resolve before giving up
  timer(2000).pipe(map(() => null)),
).pipe(
  tap((authState) => {
    if (authState?.user?.email) {
      // pass identity to Ketch via Google dataLayer
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        ketchIdentities: safeBase64Encode(JSON.stringify({ email: authState.user.email })),
      })
    }
    const disabledKetchScript = document.querySelector('script#ketch[type*=plain]')
    if (disabledKetchScript) {
      const enabledScript = disabledKetchScript.cloneNode() as HTMLScriptElement
      enabledScript.setAttribute('type', 'text/javascript')
      disabledKetchScript.parentNode?.replaceChild(enabledScript, disabledKetchScript)
    }
  }),
)
